import React from 'react';
import LoggedIn, { LoggedInProps } from './loggedin';

export type AccountDropdownLook = Pick<
  LoggedInProps,
  'className' | 'rowClassName' | 'rowButtonClassName' | 'logoutTriggerClassName'
>;

interface Props extends AccountDropdownLook {
  loggedIn: boolean;
  closePopover?: () => void;
}

const AccountDropdown: React.FC<Props> = ({ loggedIn, closePopover, ...look }) =>
  loggedIn ? <LoggedIn closePopover={closePopover} {...look} /> : <></>;

export default AccountDropdown;
